import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";
import en from "./locales/en.json";

const PREFS_KEY = "onenext.preferences.v1";

function getStoredLocale(): "fr" | "en" {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return "fr";
    const parsed = JSON.parse(raw) as { language?: string };
    if (parsed.language === "en") return "en";
  } catch {
    // ignore
  }
  return "fr";
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: getStoredLocale(),
  fallbackLng: "fr",
  supportedLngs: ["fr", "en"],
  interpolation: { escapeValue: false },
});

export function setAppLanguage(lang: "fr" | "en") {
  i18n.changeLanguage(lang);
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    const prefs = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
    prefs.language = lang;
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore
  }
}

export default i18n;
